export enum FinalStageTypeEnum {
    BO1 = 0,
    BO3 = 1,
    BO5 = 2
}